import BasePopUp from './base';
export default BasePopUp;
